import styled from "styled-components"

export const Section = styled.section`
  padding: 2rem 0;
  width: 90vw;
  max-width: 1300px;
  margin: 0 auto;
`
